export default __webpack_public_path__ + "static/media/README.c8e8266b.md";